import { useEffect } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { getDraftPayment } from '../../draft/payment/selectors';
import { getZoneName } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
import { useAuthorizationState } from '../authorization/hooks';
import { setValue } from '../../draft/actions';
import { coupon as couponPath } from '../../draft/paths';
import { useCouponVersionAsync } from '../coupon-activate/hooks';
export var useCouponListAsync = createAsyncState('couponList');
export var useCouponListQuery = function () {
    var _a, _b;
    var _c = useCouponListAsync(), asyncState = _c[0], actions = _c[1];
    var couponList = useAPIContext().couponList;
    var _d = useStoreContext(), state = _d[0], dispatch = _d[1];
    var isAuthorized = ((_a = useAuthorizationState().data) === null || _a === void 0 ? void 0 : _a.authorization_status) === 'authorized';
    var couponVersionState = useCouponVersionAsync()[0];
    var _e = isAuthorized
        ? [getDraftPayment(state), getZoneName(state), ((_b = couponVersionState.data) === null || _b === void 0 ? void 0 : _b.version) || undefined]
        : [], payment = _e[0], zoneName = _e[1], version = _e[2];
    useEffect(function () {
        if (couponList && payment && zoneName) {
            actions.start();
            return couponList({
                body: {
                    payment: {
                        payment_method_id: payment.id,
                        type: payment.type,
                    },
                    zone_name: zoneName,
                    version: version,
                },
                onError: actions.error,
                onSuccess: function (response) {
                    var _a;
                    var activeCouponCode = (_a = response === null || response === void 0 ? void 0 : response.coupons.find(function (coupon) { return coupon.status === 'valid' && coupon.selected; })) === null || _a === void 0 ? void 0 : _a.code;
                    // обновим купон в черновике
                    dispatch(setValue({
                        path: couponPath,
                        value: activeCouponCode,
                    }));
                    actions.success(response);
                },
            });
        }
    }, [dispatch, payment, zoneName, couponList, actions, version]);
    return asyncState;
};
